<template>
  <Layout>
    <div class="page-header">
      <div class="page-title">
        <h2>{{$t('blogs_titles')}}</h2>
        <h5>{{$t('create_manage_blogs')}}</h5>
      </div>

      <div class="actions">
        <BlogFilters />
        <ExpandableSearch />

        <div class="log-icon-wrapper">
          <img src="@/assets/images/logIconNew.svg" @click="showLogModal" class="log-icon" />
          <span class="tooltip">{{ $t('log_records') }}</span>
        </div>

        <LogModal
            :visible="isLogModalVisible"
            :on-hide="hideLogModal"
            :data="logData"
            :total-items="logMeta.total"
            :current-page="logMeta.currentPage"
            :per-page="logMeta.perPage"
            :on-page-change="handleLogPageChange"
        />

        <router-link to="/blog/new">
          <div class="justify-end-add-btn no-text-select">
            <img src="../assets/images/plus.svg" />
            <span>{{$t('add_new')}}</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="blog-list-grid">
      <BlogCard
          v-for="item in blogData.data"
          :is-loading="isLoading"
          :image="item.avatarUrl"
          :title="item.name"
          :description="stripHtmlTags(truncate(item.description, 100))"
          :tags="item.tags.map((x) => x.name)"
          :likes="item.likeCount"
          :viewCount="item.viewCount"
          :to="`/blog/${item.blogId}`"
      />

      <BlogCard v-if="isLoading" />
      <BlogCard v-if="isLoading" />
      <BlogCard v-if="isLoading" />
      <BlogCard v-if="isLoading" />
    </div>


    <div class="pagination-align-center">
      <Pagination :current-page="currentPage" :total-items="blogData.total" :per-page="20" :on-page-change="handlePage"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import Pagination from "@/components/Pagination.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import BlogCard from "@/components/BlogCard.vue";
import blogService from "@/service/blogService";
import {handleErrorResponse, stripHtmlTags, truncate} from "@/utils/utils";
import PageCard from "@/components/PageCard.vue";
import BlogFilters from "@/components/tables/Blog/BlogFilters.vue";
import LogModal from "@/components/modals/LogModal.vue";

export default {
  name: 'Blogs',
  components: {
    LogModal,
    BlogFilters,
    PageCard,
    BlogCard,
    ExpandableSearch,
    Pagination,
    Layout
  },
  data() {
    return {
      logData: [],
      logMeta: {
        total: 0,
        currentPage: 1,
        perPage: 20
      },
      isLogModalVisible: false,
      isLoading: true,
      blogData: {
        data: [],
        total: 0
      },
      currentPage: 1,
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },

  mounted() {
    this.getLogs(1);
  },
  methods: {
    getLogs(page = 1) {
      blogService.getLogs(this.$i18n.locale, page, 20).then((res) => {
        const response = res.data.data;
        this.logData = response.data;
        this.logMeta = {
          total: response.total,
          currentPage: response.current_page,
          perPage: response.per_page
        };
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar);
      });
    },

    handleLogPageChange(page) {
      if (this.logMeta.currentPage === page) return;

      this.logMeta.currentPage = page;
      this.getLogs(page);
    },

    showLogModal() {
      this.isLogModalVisible = true;
    },
    hideLogModal() {
      this.isLogModalVisible = false;
    },
    truncate,
    stripHtmlTags,
    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;

      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'createdAt',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'createdAtEnd',
          value: routeQuery.addedDateEnd
        });
      }

      if (routeQuery.status) {
        if(routeQuery.status === "1") {
          tempFilters.push({
            key: 'status',
            value: "1"
          })}
        else if(routeQuery.status==="0"){
          tempFilters.push({
            key: 'status',
            value: "0"
          })
        }
      }

      blogService.getBlogs(page, tempFilters).then((res) => {
        this.blogData = res.data.data;
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar);
      }).finally(() => {
        this.isLoading = false;
      });
    },
  }
}
</script>

<style scoped>
.page-title {
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
}
.filter-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.filter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
.filter-dropdown {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
  background-color: #f2f2f2;
  position: relative;
  cursor: pointer;
}
.dropdown-text {
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
}

.blog-list-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.log-icon-wrapper {
  position: relative;
  cursor: pointer;
}

.log-icon-wrapper .tooltip {
  visibility: hidden;
  background-color: #040C2D;
  color: white;
  text-align: center;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 10px;
  font-family: euclid_semi_bold;


  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);


  opacity: 0;
  transition: opacity 0.3s;
}

.log-icon-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}


.log-icon-wrapper .tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #040C2D transparent transparent transparent;
}

@media (max-width: 1024px) {
  .blog-list-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .blog-list-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
